export default "__VITE_ASSET__CUAfNmB0__"